export function Footer() {
  return (
    <footer className="bg-[#05152a] text-gray-500 py-10 text-center text-sm border-t border-gray-800 mt-auto w-full">
      <div className="max-w-7xl mx-auto px-4">
        <p>
          &copy; 2026 Loja Maçônica Hórus Nº 147. São José, SC. Todos os
          direitos reservados.
        </p>
        <p className="mt-2 text-xs opacity-70">
          Desenvolvido com Sabedoria, Força e Beleza.
        </p>
      </div>
    </footer>
  );
}
export default Footer;
